import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';
import { useMobileMenu } from './Footer';

const SalesProcess: React.FC = () => {
  const { language } = useLanguage();
  const { closeMobileMenu } = useMobileMenu();
  
  const steps = [
    {
      id: 1,
      title: language === 'en' ? 'Initial Contact' : 'Kapcsolatfelvétel',
      description: language === 'en' 
        ? 'Get in touch with our team to discuss your CRM needs' 
        : 'Vegye fel a kapcsolatot csapatunkkal, hogy megbeszéljük CRM igényeit',
      icon: (
        <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
        </svg>
      )
    },
    {
      id: 2,
      title: language === 'en' ? 'Needs Assessment' : 'Igényfelmérés',
      description: language === 'en' 
        ? 'We analyze your business processes to identify your exact requirements' 
        : 'Elemezzük üzleti folyamatait a pontos követelmények meghatározásához',
      icon: (
        <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
        </svg>
      )
    },
    {
      id: 3,
      title: language === 'en' ? 'Custom Proposal' : 'Ajánlatadás',
      description: language === 'en' 
        ? 'We prepare a tailored proposal with pricing based on your specific needs' 
        : 'Személyre szabott ajánlatot készítünk az Ön egyedi igényei alapján',
      icon: (
        <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      )
    },
    {
      id: 4,
      title: language === 'en' ? 'Implementation' : 'Implementálás',
      description: language === 'en' 
        ? 'We set up your custom CRM solution and train your team on its use' 
        : 'Beállítjuk az egyedi CRM megoldást és betanítjuk csapatát annak használatára',
      icon: (
        <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      )
    },
    {
      id: 5,
      title: language === 'en' ? 'Ongoing Support' : 'Üzemeltetés',
      description: language === 'en' 
        ? 'We provide continuous support and refine your CRM based on feedback' 
        : 'Folyamatos támogatást nyújtunk és finomítjuk a CRM-et a visszajelzések alapján',
      icon: (
        <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      )
    }
  ];

  return (
    <div id="sales-process-section" className="bg-white py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-base font-semibold text-indigo-600 tracking-wide uppercase">
            {language === 'en' ? 'Our Process' : 'Folyamatunk'}
          </h2>
          <p className="mt-2 text-3xl font-extrabold text-gray-900 sm:text-4xl">
            {language === 'en' 
              ? 'How We Work With You' 
              : 'Hogyan dolgozunk Önnel'}
          </p>
          <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-500">
            {language === 'en'
              ? 'From initial contact to ongoing support, our streamlined process ensures your CRM solution perfectly fits your business needs'
              : 'A kapcsolatfelvételtől a folyamatos támogatásig, hatékony folyamatunk biztosítja, hogy a CRM megoldás tökéletesen illeszkedjen vállalkozása igényeihez'}
          </p>
        </div>

        {/* Modern vertical timeline for both mobile and desktop */}
        <div className="mx-auto mt-16 max-w-4xl relative pl-8 md:pl-0">
          {/* Vertical line */}
          <div className="absolute left-4 md:left-1/2 top-0 h-full w-0.5 bg-indigo-200 transform md:-translate-x-px"></div>
          
          <div className="space-y-12">
            {steps.map((step, index) => (
              <div key={step.id} className={`relative flex flex-col md:flex-row ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`}>
                {/* Circle on the line */}
                <div className="absolute left-0 md:left-1/2 transform -translate-x-4 md:-translate-x-4 -mt-0.5 w-8 h-8 bg-indigo-600 text-white rounded-full flex items-center justify-center font-bold z-10">
                  {step.id}
                </div>
                
                {/* Content */}
                <div className={`md:w-1/2 ${index % 2 === 0 ? 'md:pr-8' : 'md:pl-8'}`}>
                  <div className="bg-white p-4 rounded-lg ml-6 md:ml-0 border border-indigo-100 shadow-sm hover:shadow-md hover:border-indigo-200 transition-all duration-300">
                    <div className="flex items-center">
                      <div className="mr-3 text-indigo-500 p-2 rounded-full bg-indigo-50">
                        {step.icon}
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900">{step.title}</h3>
                    </div>
                    <p className="mt-2 text-gray-600">{step.description}</p>
                  </div>
                </div>
                
                {/* Spacer for alternating layout */}
                <div className="hidden md:block md:w-1/2"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <Link 
            to="/contact"
            onClick={closeMobileMenu}
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 transition-all duration-200"
          >
            {language === 'en' ? 'Start Your Journey Today' : 'Kezdje el az utat még ma'}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SalesProcess; 